// components/ActivityTable.jsx
import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import React, { useState } from 'react';

const ActivityTable = ({ admissionData }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Not Discharged';
    const date = new Date(dateString);
    return isNaN(date) ? 'Invalid Date' : date.toLocaleDateString();
  };

  return (
    <Paper 
      elevation={3} 
      sx={{ 
        borderRadius: 3, 
        overflow: 'hidden'
      }}
    >
      <Box 
        sx={{ 
          p: 2, 
          background: 'black', 
          color: 'white',
          borderBottom: '1px solid rgba(224, 224, 224, 0.4)'
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Recent Activity
        </Typography>
      </Box>
      
      <TableContainer sx={{ maxHeight: 500 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                Admission No
              </TableCell>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                Patient ID
              </TableCell>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                Patient Name
              </TableCell>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                Phone
              </TableCell>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                Admit Date
              </TableCell>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                Department
              </TableCell>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {admissionData && admissionData.length > 0 ? (
              admissionData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((admission) => (
                <TableRow 
                  key={admission.id}
                  hover
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell>{admission.admissionNo}</TableCell>
                  <TableCell>{admission.patientSerialNo}</TableCell>
                  <TableCell>{admission.patientName}</TableCell>
                  <TableCell>{admission.phone}</TableCell>
                  <TableCell>{formatDate(admission.admitDate)}</TableCell>
                  <TableCell>{admission.departmentName}</TableCell>
                  <TableCell>
                    <Chip
                      label={admission.status}
                      color={
                        admission.status === 'Active'
                          ? 'success'
                          : admission.status === 'In Active'
                          ? 'default'
                          : admission.status === 'Discharged'
                          ? 'primary'
                          : 'warning'
                      }
                      size="small"
                      sx={{ 
                        fontWeight: 600,
                        backgroundColor: 
                          admission.status === 'Active'
                            ? '#4caf50'
                            : admission.status === 'In Active'
                            ? '#9e9e9e'
                            : admission.status === 'Discharged'
                            ? '#2196f3'
                            : '#ff9800',
                        color: 'white'
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  <Typography variant="body1" sx={{ py: 2 }}>
                    No admission data available
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      
      {/* {admissionData && admissionData.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={admissionData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            borderTop: '1px solid rgba(224, 224, 224, 0.4)',
            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
              margin: 0
            }
          }}
        />
      )} */}
    </Paper>
  );
};

export default ActivityTable;